<template lang="pug">
    .inibicao-alertas-em-lote
        BaseHeader(
            :titulo="$t('mensagens.inibicaoAlertasLote.titulo')"
            :exibeBotao="true"
            icon="el-icon-download"
            :btnTexto="$t('mensagens.inibicaoAlertasLote.downloadTemplate')"
            @btnHeaderClicado="downloadTemplate"
            :exibeBotaoSecundario="true"
            :btnTextoSecundario="$t('mensagens.inibicaoAlertasLote.uploadPlanilha')"
            @btnHeaderClicadoSecundario="showModalUpload = true"
        )

        ModalUploadInibicaoAlertaEmLote(
            :show.sync="showModalUpload"
            @atualizar="carregarPlanilhas"
        )

        .view-container-base-header
            .estatisticas-container.mb-4
                .estatistica-card
                    .estatistica-icon
                        i.el-icon-document
                    .estatistica-content
                        .estatistica-valor {{ totalizadores.totalPlanilhas }}
                        .estatistica-label {{ $t('mensagens.inibicaoAlertasLote.cards.totalPlanilhas') }}

                .estatistica-card.info
                    .estatistica-icon
                        i.el-icon-finished
                    .estatistica-content
                        .estatistica-valor {{ totalizadores.validando }}
                        .estatistica-label {{ $t('mensagens.inibicaoAlertasLote.cards.validando') }}

                .estatistica-card.success
                    .estatistica-icon
                        i.el-icon-circle-check
                    .estatistica-content
                        .estatistica-valor {{ totalizadores.processadas }}
                        .estatistica-label {{ $t('mensagens.inibicaoAlertasLote.cards.processadas') }}

                .estatistica-card.error
                    .estatistica-icon
                        i.el-icon-warning-outline
                    .estatistica-content
                        .estatistica-valor {{ totalizadores.comErros }}
                        .estatistica-label {{ $t('mensagens.inibicaoAlertasLote.cards.comErros') }}

                .estatistica-card.warning
                    .estatistica-icon
                        i.el-icon-time
                    .estatistica-content
                        .estatistica-valor {{ totalizadores.aguardando }}
                        .estatistica-label {{ $t('mensagens.inibicaoAlertasLote.cards.aguardando') }}

            .tabela
                .table-scroll
                    el-table(
                        :data="planilhas"
                        v-loading="loading"
                    )
                        el-table-column(prop='id', :label="$t('mensagens.inibicaoAlertasLote.tabela.id')", min-width='100')
                        el-table-column(prop='nomeUsuario', :label="$t('mensagens.inibicaoAlertasLote.tabela.nomeUsuario')", min-width='400')
                        el-table-column(prop='status', :label="$t('mensagens.inibicaoAlertasLote.tabela.status.label')", min-width='400', align='center')
                            .template(slot-scope='scope')
                                label(:class='"status-label " + scope.row.status') {{ $t('mensagens.inibicaoAlertasLote.tabela.status.' + scope.row.status) }}
                        el-table-column(prop='dataCadastroFormatada', :label="$t('mensagens.inibicaoAlertasLote.tabela.dataCadastro')", min-width='200')
                        el-table-column(min-width='50', align='center', :label="$t('mensagens.inibicaoAlertasLote.tabela.acoes.label')")
                            .template(slot-scope='scope')
                                el-dropdown.acoes(trigger='click', v-if="scope.row.status !== 'VALIDANDO'")
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical

                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            @click.native="downloadPlanilha(scope.row.id, 'ORIGINAL')"
                                        )
                                            | {{ $t('mensagens.inibicaoAlertasLote.tabela.acoes.downloadPlanilhaOriginal') }}

                                        el-dropdown-item(
                                            v-if="scope.row.status === 'PROCESSADO_COM_ERRO' || scope.row.status === 'VALIDADO_COM_ERRO'"
                                            @click.native="downloadPlanilha(scope.row.id, 'ERRO')"
                                        )
                                            | {{ $t('mensagens.inibicaoAlertasLote.tabela.acoes.downloadPlanilhaComErros') }}

                                span(v-else)
                                    i.el-icon-loading

                        template(slot='empty')
                            el-empty(:description="$t('mensagens.inibicaoAlertasLote.emptyTemplate')")
                BasePaginacao(
                    :page.sync='paginacao.page',
                    :size.sync='paginacao.size',
                    :total='totalResultados',
                    @alterar='carregarPlanilhas'
                )

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';
import ModalUploadInibicaoAlertaEmLote from '@/components/operacao/gestao/ModalUploadInibicaoAlertaEmLote';
import BasePaginacao from '@/components/vegaComponents/BasePaginacao.vue';
import { TIPO_PLANILHA_OPERACAO } from '@/constants/tipoPlanilhaOperacao';

export default {
    name: 'InibicaoAlertasEmLote',
    components: {
        BaseHeader,
        ModalUploadInibicaoAlertaEmLote,
        BasePaginacao
    },
    data() {
        return {
            loading: false,
            planilhas: [],
            paginacao: {
                page: 1,
                size: 10
            },
            totalResultados: 0,
            totalizadores: {
                totalPlanilhas: 0,
                validando: 0,
                processadas: 0,
                comErros: 0,
                aguardando: 0
            },
            pollingInterval: null,
            showModalUpload: false
        };
    },
    computed: {
        temItensEmAndamento() {
            return this.planilhas.some(p =>
                p.status === 'VALIDANDO' ||
                p.status === 'EM_PROCESSAMENTO' ||
                p.status === 'AGUARDANDO_PROCESSAMENTO'
            );
        }
    },
    created() {
        this.carregarPlanilhas();
    },
    mounted() {
        this.iniciarPolling();
    },
    beforeDestroy() {
        this.pararPolling();
    },
    methods: {
        async carregarPlanilhas() {
            try {
                this.loading = true;
                const response = await OperacaoService.listarPlanilhasOperacaoEmLote(TIPO_PLANILHA_OPERACAO.INIBICAO_ALERTAS, {
                    page: this.paginacao.page - 1,
                    size: this.paginacao.size
                });
                this.planilhas = response.data.resultados;
                this.totalResultados = response.data.totalResultados;
                this.totalizadores = response.data.totalizadores;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.inibicaoAlertasLote.erroBuscarLista')
                });
            } finally {
                this.loading = false;
            }
        },
        iniciarPolling() {
            this.pollingInterval = setInterval(() => {
                if (this.temItensEmAndamento) {
                    this.carregarPlanilhas();
                }
            }, 15000);
        },
        pararPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        async downloadPlanilha(id, tipo) {
            await OperacaoService.downloadPlanilhaOperacaoEmLote(id, tipo)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    })
                );
        },
        async downloadTemplate() {
            await OperacaoService.downloadTemplatePlanilhaOperacaoEmLote(TIPO_PLANILHA_OPERACAO.INIBICAO_ALERTAS)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    })
                );
        }
    }
};
</script>

<style scoped lang="scss">
.view-container-base-header{
    .estatisticas-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 20px;
        margin-bottom: 20px;

        .estatistica-card {
            background: var(--white);
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            gap: 15px;
            transition: transform 0.2s;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            .estatistica-icon {
                font-size: 40px;
                color: var(--primary);

                i {
                    display: block;
                }
            }

            .estatistica-content {
                flex: 1;

                .estatistica-valor {
                    font-size: 28px;
                    font-weight: bold;
                    color: var(--primary);
                    line-height: 1;
                }

                .estatistica-label {
                    font-size: 14px;
                    color: var(--primary-font-color);
                    margin-top: 5px;
                }
            }

            &.info {
                .estatistica-icon {
                    color: #409EFF;
                }
                .estatistica-valor {
                    color: #409EFF;
                }
            }

            &.success {
                .estatistica-icon {
                    color: #67C23A;
                }
                .estatistica-valor {
                    color: #67C23A;
                }
            }

            &.error {
                .estatistica-icon {
                    color: #F56C6C;
                }
                .estatistica-valor {
                    color: #F56C6C;
                }
            }

            &.warning {
                .estatistica-icon {
                    color: #E6A23C;
                }
                .estatistica-valor {
                    color: #E6A23C;
                }
            }
        }
    }

    .tabela {
        border-radius: 5px;
        overflow: hidden;
        background-color: var(--white);
        height: 100%;
        width: 100%;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        .table-scroll {
            max-height: 500px;
            overflow-y: auto;

            .status-label {
                border-radius: 20px;
                text-align: center;
                max-width: 250px;
                padding: 5px 10px;
            }

            .VALIDANDO {
                border: 1px solid var(--tag-info-border, #409EFF);
                background-color: var(--tag-info-background, #ECF5FF);
                color: var(--tag-info-text, #409EFF);
            }

            .VALIDADO_COM_ERRO {
                border: 1px solid var(--tag-danger-border);
                background-color: var(--tag-danger-background);
                color: var(--tag-danger-text);
            }

            .AGUARDANDO_PROCESSAMENTO {
                border: 1px solid var(--tag-warning-border);
                background-color: var(--tag-warning-background);
                color: var(--tag-warning-text);
            }

            .EM_PROCESSAMENTO {
                border: 1px solid var(--tag-info-border, #409EFF);
                background-color: var(--tag-info-background, #ECF5FF);
                color: var(--tag-info-text, #409EFF);
            }

            .PROCESSADO {
                border: 1px solid var(--tag-success-border);
                background-color: var(--tag-success-background);
                color: var(--tag-success-text);
            }

            .PROCESSADO_COM_ERRO {
                border: 1px solid var(--tag-danger-border);
                background-color: var(--tag-danger-background);
                color: var(--tag-danger-text);
            }
        }
        .acoes:hover {
            cursor: pointer;
        }
    }
}
</style>
